import { FETCH_LANDING_PAGE_COUNT } from "../actions/types";

const initialState = {
  isFetching: true,
  epaIdCount: 0,
  manifestCount: 0,
  tonnageCount: 0,
};

export default function (state = initialState, actions) {
  switch (actions.type) {
    case FETCH_LANDING_PAGE_COUNT: {
      return {
        ...state,
        isFetching: actions.isFetching,
        epaIdCount: actions.payload.epaIdCount,
        manifestCount: actions.payload.manifestCount,
        tonnageCount: actions.payload.tonnageCount,
      };
    }
    default:
      return state;
  }
}
